import React from 'react';
import Navbar from '../../components/Navbar';
import PatientDetail from '../../components/Patient/PatientDetail';
import './PatientDetailPage.css';

const PatientDetailPage = () => {
  return (
    <div className="patient-detail-page">
      <Navbar />
      <div className="detail-container">
        <PatientDetail />
      </div>
    </div>
  );
};

export default PatientDetailPage;
